import { type FC } from 'react';

interface VisitorIdentificationProps {
  defer?: boolean;
}

/**
 * Sitecore-only "visitor identification" stub.
 *
 * The legacy implementation injects a `<script>` tag into `<head>` so
 * Sitecore Analytics can tell visitors from bots. CMS-agnostic code is
 * provider-blind, so this Phase A no-op preserves the export name. Containers
 * that need real VI keep importing it from `@eneco/sitecore-common` until
 * Phase E moves the concern into the adapter.
 */
export const VisitorIdentification: FC<VisitorIdentificationProps> = () => null;
VisitorIdentification.displayName = 'VisitorIdentification';
